import { defaultStackForGroup } from 'src/stack/screens';

const MOBILE_SUPPORTED_STACKS = new Set(['appUser', 'appViewOnlyUser']);

export const isMobileSupportedGroup = (groupName: string) =>
    MOBILE_SUPPORTED_STACKS.has(defaultStackForGroup(groupName));

export const isMobileSupportedStack = (stackName?: string) =>
    !!stackName && MOBILE_SUPPORTED_STACKS.has(stackName);
